import { Box, Text } from '@factorialco/deprecated-design-system'

import TimePicker from 'modules/core/components/Inputs/TimePicker'
import i18n from 'modules/core/lib/i18n'

import TooltipIcon from 'modules/shift_management/components/ShiftManagement/TooltipIcon'
import useIsTimeFormat24H from 'modules/shift_management/hooks/useIsTimeFormat24H'
import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'

interface Props {
  form: PlannedBreakForm
  error?: string
  showNotice?: boolean
  newVersion?: boolean
}

const FixedBreakInputs = ({ form, error, showNotice = false, newVersion = false }: Props) => {
  const { isTimeFormat24H } = useIsTimeFormat24H()
  const startField = form.get('start_at')
  const endField = form.get('end_at')
  const localErrors = startField.errors || []
  const fieldError = error || localErrors[0]

  return (
    <Box gap="s16" className={fieldError && 'error-anchor'}>
      <Box gap="s4">
        <Box flexDirection="row" alignItems="center" gap="s12">
          {newVersion && (
            <TooltipIcon.Medium
              icon="lock-locked"
              label={i18n.t('company_settings.time.breaks.time_frame')}
              color="grey1000"
            />
          )}
          <Box flexDirection="row" alignItems="center" gap="s8">
            <TimePicker
              field={startField}
              onBlur={() => startField.setErrors([])}
              isTimeFormat24H={isTimeFormat24H}
              isNotValid={!!fieldError}
              hideError
            />
            <Box>-</Box>
            <TimePicker
              field={endField}
              onBlur={() => endField.setErrors([])}
              isTimeFormat24H={isTimeFormat24H}
              isNotValid={!!fieldError}
              hideError
            />
          </Box>
        </Box>
        {fieldError && (
          <Box alignItems="flexStart">
            <Text size="200" color="radicalRed1000" capitalize>
              {fieldError}
            </Text>
          </Box>
        )}
      </Box>
      {showNotice && (
        <Text size="200" capitalize>
          {i18n.t('shift_management.breaks.notice.fixed')}
        </Text>
      )}
    </Box>
  )
}

export default FixedBreakInputs
